import { IFormConfig, IFieldDefinition, IFieldContainer } from 'app/interfaces';
import { fieldsMap } from './../fields';

const fields: (IFieldContainer|IFieldDefinition)[] = [
	{
		config: {
			flexLayout: 'row'
		},
		fields: [
			fieldsMap.get('booking_date'),
			fieldsMap.get('disable_export_sale_operation'),
			//fieldsMap.get('disable_export')
		]
	},
	{
		config: {
			flexLayout: 'row'
		},
		fields: [
			fieldsMap.get('entity_id'),
			fieldsMap.get('entity_primary_email'),
		]
	},
	{
		config: {
			flexLayout: 'row'
		},
		fields: [
			fieldsMap.get('entity_birth_location'),
			fieldsMap.get('entity_birth_day'),
			fieldsMap.get('entity_nation_code'),
		]
	},
	{
		config: {
			flexLayout: 'row'
		},
		fields: [
			fieldsMap.get('entity_street'),
			fieldsMap.get('entity_zip_code'),
			fieldsMap.get('entity_city'),
		]
	},
	fieldsMap.get('tel'),
	fieldsMap.get('entity_customer_id'),
	{
		config: {
			flexLayout: 'row'
		},
		fields: [
			fieldsMap.get('payment_type_id'),
			fieldsMap.get('discount_rule_list_id'),
		]
	},
	{
		config: {
			flexLayout: 'row'
		},
		fields: [
			fieldsMap.get('origin_channel_voucher_code'),
			fieldsMap.get('online_order_id'),
		]
	},
	fieldsMap.get('note')
];

const baseInfoFormConfig: IFormConfig = {
	fields,
	formStyle: 'style-1'
};

export default baseInfoFormConfig;
